import React, { useEffect, useState } from 'react';
import { TimerProps } from './Timer.types';
import styles from './Timer.module.css';
import TimerSection from './TimerSection';

const Timer = ({ timerData }: TimerProps) => {
  const [days, setDays] = useState<string>('00');
  const [hours, setHours] = useState<string>('00');
  const [minutes, setMinutes] = useState<string>('00');
  const [seconds, setSeconds] = useState<string>('00');
  const timer = React.useRef<NodeJS.Timer | null>(null);

  useEffect(() => {
    timer.current = setInterval(() => {
      showRemaining();
    }, 1000);
  }, []);

  const showRemaining = () => {
    const now = new Date().getTime();
    const end = new Date(timerData.endTime).getTime();
    // const end = new Date('2023-11-12T23:59:59.383+03:00').getTime();
    const distance = end - now;

    if (distance < 0 && timer?.current) {
      return clearInterval(timer.current);
    }
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;

    let days: number | string = Math.floor(distance / day);
    if (days < 10) days = '0' + days;
    let hours: number | string = Math.floor((distance % day) / hour);
    if (hours < 10) hours = '0' + hours;
    let minutes: number | string = Math.floor((distance % hour) / minute);
    if (minutes < 10) minutes = '0' + minutes;
    let seconds: number | string = Math.floor((distance % minute) / second);
    if (seconds < 10) seconds = '0' + seconds;

    setDays(days.toString());
    setHours(hours.toString());
    setMinutes(minutes.toString());
    setSeconds(seconds.toString());
  };
  // 2023-11-07T23:59:59.383+03:00

  return (
    <div className={styles.timer}>
      <div className={styles.wrapper}>
        <div className={styles.title} style={{ color: timerData.bgColor }}>
          до конца акции
        </div>
        <div className={styles.counter}>
          <div className={styles.counter__days}>
            <TimerSection
              firsNum={days[0]}
              secNum={days[1]}
              bgColor={timerData.bgColor}
              numColor={timerData.numColor}
            />
            <div style={{ color: timerData.bgColor }}>дней</div>
          </div>
          <div className={styles.separator} style={{ color: timerData.bgColor }}>
            :
          </div>
          <div className={styles.counter__days}>
            <TimerSection
              firsNum={hours[0]}
              secNum={hours[1]}
              bgColor={timerData.bgColor}
              numColor={timerData.numColor}
            />
            <div style={{ color: timerData.bgColor }}>часов</div>
          </div>
          <div className={styles.separator} style={{ color: timerData.bgColor }}>
            :
          </div>
          <div className={styles.counter__days}>
            <TimerSection
              firsNum={minutes[0]}
              secNum={minutes[1]}
              bgColor={timerData.bgColor}
              numColor={timerData.numColor}
            />
            <div style={{ color: timerData.bgColor }}>минут</div>
          </div>
          <div className={styles.separator} style={{ color: timerData.bgColor }}>
            :
          </div>
          <div className={styles.counter__days}>
            <TimerSection
              firsNum={seconds[0]}
              secNum={seconds[1]}
              bgColor={timerData.bgColor}
              numColor={timerData.numColor}
            />
            <div style={{ color: timerData.bgColor }}>секунд</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timer;
